<template>
  <v-app style="background-color: transparent;">
    <div class="card-container" :class="{'flip': flipped}" :style="{height: height}">
      <v-card
        v-for="side in ['front', 'back']"
        :key="side"
        :class="side"
        class="p-1"
        :width="width"
        :height="height"
        :style="cardStyle"
      >
        <div class="flip-icon">
          <v-btn @click.stop="flip" icon color="#3F51B5">
            <v-icon large>mdi-rotate-3d-variant</v-icon>
          </v-btn>
        </div>
        <div v-show="side == 'front'">
          <div class="checkbox" v-if="!hideCheckbox">
            <slot name="checkbox"></slot>
          </div>
          <div class="card-title">
            <span class="d-block product-code" :class="!hideCheckbox && 'has-checkbox'">
              {{ splitTitle.code }}
            </span>
            <span class="d-block text-truncate product-name">
              {{ splitTitle.title }}
            </span>
            <span class="d-block product-code">
              {{ referenceNumber }}
            </span>
            <slot name="extra-title"></slot>
          </div>
          <div class="img-container">
            <img :src="img ? img : './img/shopping-bag.png'" alt="Card image" />
          </div>
            <slot name="img-footer"></slot>
        </div>
        <div v-for="(item, itemIndex) in data" :key="`item${itemIndex}`">
          <div class="text" v-if="(side == 'front' && editableItems.includes(item.key)) || (side == 'back' && !editableItems.includes(item.key))">
            <div v-if="!hiddenItems.includes(item.key)">
              <h4 v-if="item.title">{{ item.title }}</h4>
              <v-divider class="my-2" />
              <slot name="item" :prop="item">
                <v-row no-gutters v-for="(prop, propIndex) in item.props"
                  :key="`prop${propIndex}`">
                  <v-col cols="auto" class="mr-auto py-1">
                    {{ prop.name }}:
                  </v-col>
                  <v-col class="py-1 pl-2">
                    <v-skeleton-loader v-show="loading" type="text" max-width="80" class="mt-1" />
                    <slot v-if="!loading" name="prop" :prop="prop">
                      <span class="item-value">{{ prop.value }}</span>
                    </slot>
                  </v-col>
                </v-row>
              </slot>
            </div>
          </div>
        </div>
        <div class="actions-container" v-if="side == 'front'">
          <slot name="actions"></slot>
        </div>
      </v-card>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'flip-card',
  props: {
    data: {
      type: Array,
      required: true
    },
    value: {
      required: false,
      default: null
    },
    title: {
      type: String,
      required: false
    },
    referenceNumber: {
      type: String,
      required: false
    },
    img: {
      type: String,
      required: false,
      default: './img/shopping-bag.png'
    },
    hideCheckbox: {
      type: Boolean,
      default: false
    },
    editableItems: {
      required: false,
      default: () => []
    },
    hiddenItems:{
      require: false,
      default: () => []
    },
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    cardStyle: {
      type: Object,
      required: false,
    },
    columnSize: {
      type: String,
      required: false,
      default: '2'
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      flipped: false,
      select: false,
      selectedValue: this.value ?? this.data
    }
  },
  watch: {
    select: {
      handler: function(val) {
        this.$emit('select', this.selectedValue, val)
      }
    }
  },
  computed: {
    splitTitle() {
      let result = this.title.split(' - ')
      return {
        code: result[0],
        title: result[1]
      }
    }
  },
  methods: {
    flip() {
      this.flipped = !this.flipped
      this.$emit('flip')
    }
  }
}
</script>

<style scoped>
.actions-container {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.card-container {
  position: relative;
  transform-style: preserve-3d;
  perspective: 2500px;
  display: flex;
  justify-content: center;
}

.back, .front {
  position: absolute;
  top: 0;
  transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
  backface-visibility: hidden;
}
.front h4, .back h4 {
  font-size: 1.2em;
  font-weight: 600;
  padding-top: 1em;
}
.front p, .back p {
  margin: 0;
}

.front:after {
  position: absolute;
  top: 0;
  z-index: 1;
  content: "";
  display: block;
  backface-visibility: hidden;
}

.back {
  position: absolute;
  top: 0;
}
.card-container .back {
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.card-container .front {
  transform: rotateY(0deg);
  transform-style: preserve-3d;
}
.card-container.flip .back {
  transform: rotateY(0deg);
}
.card-container.flip .front {
  -webkit-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  transform-style: preserve-3d;
}
.flip-icon {
  position: absolute;
  top: 10px;
  right: 10px;
}
.checkbox {
  position: absolute;
  top: -2px;
  left: 14px;
}
.card-title {
  font-size: 1.2em;
  padding: 0 2em 1em 0;
}
.img-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 368px;
  overflow: hidden;
  background-color: #f2f2f2;
}
.item-value {
  font-weight: bold;
}
.product-code {
  font-weight: bold;
}
.has-checkbox {
  padding-left: 30px;
}
.product-name {
  max-width: 380px;
}
::v-deep .v-application--wrap {
  min-height: fit-content;
  height: 790px;
}
</style>
